import { reaction } from 'mobx';
import { useEffect, useState } from 'react';

import { terminalIntegrationStore } from '@/integrations/terminal-integration.store';

interface TerminalIntegrationState {
  terminalEnabled: boolean;
  terminalLoaded: boolean;
}

const read = (): TerminalIntegrationState => ({
  terminalEnabled: terminalIntegrationStore.enabled,
  terminalLoaded: terminalIntegrationStore.loaded,
});

const same = (a: TerminalIntegrationState, b: TerminalIntegrationState) =>
  a.terminalEnabled === b.terminalEnabled &&
  a.terminalLoaded === b.terminalLoaded;

/**
 * Loads the persisted Terminal opt-in once and mirrors it into React state, so
 * callers need not be MobX observers - `useIntegrationState` memoises this
 * into grid items, and a bare store read there went stale once the store
 * loaded after first render (the card kept its + while Terminal was on).
 */
export function useTerminalIntegrationState(): TerminalIntegrationState {
  const [state, setState] = useState(read);

  useEffect(() => {
    const dispose = reaction(read, setState, { equals: same });
    if (!terminalIntegrationStore.loaded) {
      void terminalIntegrationStore.load().catch((error) => {
        console.error('Failed to load Terminal integration state:', error);
      });
    }
    return dispose;
  }, []);

  return state;
}
